import { BaseState } from '@/store/base-state';
import { Reports } from '@/modules/reports/types';
import { TableOptions } from '@/types';

export default class MoneyPlanFacts extends BaseState {
  sales: Reports.SalesPlan[] = [];
  years: number[] = [];
  total_percent = 0;
  quarter: number | null = null;
  is_download_loading = false;
  loading = false;

  filters: Reports.SalesReportsFilters = {
    quarter: null,
    year: null,
  };

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [true],
  };
}
